import { Timer } from "./Timer";

export class InputTracking {

	public start(){
		this._keyPresses = [];
		this._timer.start();
		this._keyFn = this.onKey.bind(this);
		document.addEventListener("keydown", this._keyFn);
	};

	public stop(){ this._keyPresses = []; }

	public getKeyPresses(){ return this._keyPresses.slice(); }

	public dispose(){ document.removeEventListener("keydown", this._keyFn); };

	private _timer:Timer = new Timer();
	private _keyPresses:number[] = [];
	private _keyFn:any = null;

	private onKey(e:KeyboardEvent){
		if(e.code !== "Space"){ return; }
		e.preventDefault();
		this._keyPresses.push(this._timer.getElapsed())
	}
}